export default "__VITE_PUBLIC_ASSET__7b26f7c9__"